import React from 'react';
import {closeModal} from "@/Store/Slices/ModalSlice";
import {useDispatch, useSelector} from "react-redux";
import { setImage, setIsRemove } from '@/Store/Slices/ImageSlice';

const UploadImage = () => {
  const data = useSelector(state => state.image);
  const dispatch = useDispatch();

  const removeImage = () => {
    dispatch(setIsRemove({isRemove: true}))
    dispatch(closeModal())
  }

  const saveImage = () => {
    dispatch(closeModal())
    dispatch(setImage({ src: '' }))
  };


  return (
    <div className='p-2'>
      {data.src && <img src={data.src} className='modal-height' alt={'added image'}/>}
      <div>
        <div className='text-xl'>Add this image?</div>
        <div className='flex justify-center'>
          <button onClick={removeImage} className='btn-red mx-1'>No</button>
          <button onClick={saveImage} className='btn-green mx-1'>Yes</button>
        </div>
      </div>
    </div>
  );
};

export default UploadImage;
